var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"main-app"},[_c('router-view')],1),_c('DoordashButton'),_c('Footer'),_c('FooterLogo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }